import { React, DomeComponent, DomeManipulator, DomeRouter, DataTypes } from "@lexriver/dome";
import { GlobalBasket } from "../GlobalBasket";
import { Button } from "../components/form/Button";
import { Form } from "../components/form/Form";
import { Input } from "../components/form/Input";
import { LinkIcon } from "../components/form/LinkIcon";
import { EnumIconNames } from "../enums/EnumIconNames";
import css from './FormBasketCoupon.m.scss'
import { IBasket } from "../Basket/IBasket";

interface Attrs {
    //shippingAddress?:JsonShippingAddress
    
    onCouponApplySuccessAsync?: () => Promise<void>
}

export class FormBasketCoupon extends DomeComponent<Attrs>{
    protected refCoupon!: Input
    protected refSubmit!: Button

    //protected refForm!:Form


    render() {
        return <div class={css.container}></div>
    }

    afterRender(){
        this.scheduleUpdate()
    }

    async updateAsync() {
        
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, (
            // <Form maxWidth="400px" ref={ref => this.refForm = ref}>
            <>
            <h4>У меня есть промокод</h4>
            <div class={css.grid}>
                <div class={css.column1}>
                    <Input placeholder='промокод' ref={ref => {this.refCoupon = ref; setTimeout(() => {ref.focus()}, 100)}}  onEnterKeypress={(e) => this.onSubmitAsync()} />
                </div>

                <div class={css.column2}>
                    <Button ref={ref => this.refSubmit = ref} onClick={async (e) => await this.onSubmitAsync()} text="Применить" />
                </div>
                </div>

            </>
        ))
        
    }

    async onSubmitAsync() {
        const code = this.refCoupon.getValue()
        if(!code){
            await this.refCoupon.showErrorAsync('Пожалуйста введите промокод')
            return
        }

        //this.refForm.disable()
        this.refCoupon.disable()
        await this.refSubmit.switchToLoadingStateAsync()
            
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()

        let couponApplySuccess = true
        let couponErrorMessage = ''
        try {
            await basket.applyCouponAsync(code)

        } catch (error){
            couponApplySuccess = false
            const errorMessage = ''+error
            if(errorMessage.indexOf('could-be-valid-for-retail')>=0){
                couponErrorMessage = 'Для этого промокода необходимо зарегистрироваться и войти на сайт!'
            } else {
                couponErrorMessage = 'Такой промокод не найден или более не действителен!'
            }

        }
        // console.log('result=', result)

        await this.refSubmit.switchOffLoadingStateAsync()
        this.refCoupon.enable()
        //this.refForm.enable()

        if (couponApplySuccess){
            if(this.attrs.onCouponApplySuccessAsync){
                await this.attrs.onCouponApplySuccessAsync()
            }
            this.refCoupon.clear()
        } else {
            await this.refCoupon.showErrorAsync(couponErrorMessage)
        }

        
    }
}
